import { Button, Heading, Text } from '@mallpay/orbis';
import React from 'react';

import { ReactComponent as IconWarning } from '@skippay/core/assets/icons/icon-warning-circle-filled.svg';
import { usePageview } from '@skippay/core/components/GoogleAnalytics';
import { FormattedMessage } from '@skippay/core/i18n/intl';

import { OVERVIEW } from 'constants/routes';
import { FooterButtons } from 'layout/MinimalLayout/components/FooterButtons';

function AmlPepRequired(): JSX.Element {
	usePageview({ pTitle: 'bnpl_limit_management_aml_pep_required' });

	return (
		<section className="mx-auto px-4 pt-6 pb-8">
			<div className="flex flex-col gap-8">
				<Text as="div" className="text-center">
					<IconWarning className="h-20 w-20" />
				</Text>

				<div className="flex flex-col gap-3">
					<Heading as="h1" className="text-center">
						<FormattedMessage
							id="BnplLimitManagement.amlPepRequired.title"
							defaultMessage="Limit máte předschválený, ale ještě něco chybí"
						/>
					</Heading>

					<div className="mt-4">
						<Text as="div" className="text-center">
							<FormattedMessage
								id="BnplLimitManagement.amlPepRequired.description"
								defaultMessage="Pro dokončení je potřeba splnit všechny zákonné podmínky. Co přesně chybí, zjistíte na hlavním přehledu hned nahoře."
							/>
						</Text>
					</div>
				</div>
			</div>

			<FooterButtons
				content={
					<Button
						className="w-full"
						testId="bnplAmlPepRequiredClose"
						analyticsParam="bnplAmlPepRequiredClose"
						variant="primary"
						to={OVERVIEW}
					>
						<FormattedMessage
							id="BnplLimitManagement.amlPepRequired.close"
							defaultMessage="Přejít na hlavní přehled"
						/>
					</Button>
				}
			/>
		</section>
	);
}

export default AmlPepRequired;
